import { useMutation } from '@tanstack/react-query';
import { useBackoffice } from '../../backoffice/useBackoffice';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';

export const useEditCustomer = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { developerId } = useBackoffice();
  const mutation = useMutation({
    mutationKey: ['edit-customer'],
    mutationFn: async ({
      customerId,
      payload,
    }: {
      customerId: string;
      payload: {
        bridge_customer_id?: string;
        api_corridors?: string[];
        identifying_information?: {
          dob?: string;
          id_document?: {
            type?: string;
            number?: string;
            issuing_country?: string;
          };
          tax_number?: string;
          tax_number_type?: string;
        };
        address?: {
          country_alpha_2?: string;
          city?: string;
          address_line_1?: string;
          postal_code?: string;
          state?: string;
        };
      };
    }) => {
      const token = await getAccessTokenSilently();
      const res = await axios.put(`${process.env.REACT_APP_BACKEND_API_URL}/customers/${customerId}`, payload, {
        params: {
          consumerId: developerId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res.data?.data;
    },
  });

  return mutation;
};
